module.exports = __webpack_public_path__ + "img/csc-white.af6f955f.svg";